import { useSiesta } from '../SiestaProvider';

/** Both params go together on a member's page: the backend reads them as household plus member. */
export function useHistoryScope() {
  const { chatScope } = useSiesta();
  const clientId = chatScope.clientId ?? chatScope.focusedClientId ?? undefined;
  const familyId = chatScope.familyId ?? undefined;

  return { clientId, familyId };
}
